import { render, staticRenderFns } from "./CreateServiceCatalog.vue?vue&type=template&id=77572772&scoped=true"
import script from "./CreateServiceCatalog.vue?vue&type=script&lang=js"
export * from "./CreateServiceCatalog.vue?vue&type=script&lang=js"
import style0 from "./CreateServiceCatalog.vue?vue&type=style&index=0&id=77572772&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77572772",
  null
  
)

export default component.exports